import { render, staticRenderFns } from "./view-news.vue?vue&type=template&id=6641c3ba&scoped=true&"
import script from "./view-news.vue?vue&type=script&lang=js&"
export * from "./view-news.vue?vue&type=script&lang=js&"
import style0 from "./view-news.vue?vue&type=style&index=0&id=6641c3ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641c3ba",
  null
  
)

export default component.exports